import React, { useState, useEffect } from 'react'
import Datepicker from 'gatsby-theme-kn/src/components/technical/Datepicker'
import { useTranslation } from 'react-i18next'
import {
  apiURL,
  div,
  graphPercent,
} from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import ModalModule from 'gatsby-theme-kn/src/components/modules/ModalModule'
import useModal from 'gatsby-theme-kn/src/hooks/useModal'
import ModalTransactionRanking from 'gatsby-theme-kn/src/components/modules/ModalTransactionRanking'
import ModalDebitorSearch from 'gatsby-theme-kn/src/components/modules/ModalDebitorSearch'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'

const SapServiceTransactionRanking = () => {
  const { t } = useTranslation()
  const [InputData, setInputData] = useState({
    customer_number: '',
    date_from: '',
    date_to: '',
    limit: '10',
    internal: 'false',
  })
  const [Fdata, setFdata] = useState(false)

  const [partnerPortalUrl, setPartnerPortalUrl] = useState(null)
  const { data, loading, error } = useAxiosPartnerPortal(
    partnerPortalUrl,
    Fdata,
    'post'
  )

  // Modal 1 (In der Debitorenumsatz-Anzeige -> Klick auf ein Material zB. TL oder S8)
  const [modalState1, setModalState1] = useState(false)
  const triggerModal1 = (p) => {
    const d = new FormData()
    d.append('transaction_ranking[customer_number]', p.customer_number)
    d.append('transaction_ranking[series_number]', p.series_number)
    d.append('transaction_ranking[cumulative]', p.cumulative)
    d.append('transaction_ranking[furniture]', p.furniture)
    d.append('transaction_ranking[status]', p.status)
    setModalParams1(d)
    setModalState1(true)
  }
  const closeModal1 = () => {
    setModalState1(false)
  }
  const [ModalParams1, setModalParams1] = useState(null)
  const FormSubmit1 = (e, transactionDebitorRanking = false) => {
    e.preventDefault()

    const d = new FormData()
    d.append('transaction_ranking[customer_number]', InputData.customer_number)
    d.append('transaction_ranking[date_from]', InputData.date_from)
    d.append('transaction_ranking[date_to]', InputData.date_to)
    d.append('transaction_ranking[limit]', InputData.limit)
    d.append('transaction_ranking[internal]', InputData.internal)

    // Button: Debitorenumsatz anzeigen
    if (transactionDebitorRanking) {
      d.append('transaction_ranking[furniture]', true)
      d.append('transaction_ranking[cumulative]', true)
      d.append('transaction_ranking[status]', true)
    }

    setFdata(d)
    setPartnerPortalUrl(apiURL('transaction_ranking?' + Date.now()))

    return true
  }

  // Modal 2 (Debitoren-Auswahl)
  const setDebitor = function (debitor) {
    setInputData({
      ...InputData,
      customer_number: debitor,
    })
    setModalState2(false)
  }
  const [modalState2, setModalState2] = useState(false)
  const closeModal2 = () => {
    setModalState2(false)
  }

  const [modalTitle, setModalTitle] = useState(false)

  return (
    <>
      <ModalModule
        isOpen={modalState1}
        closeModal={closeModal1}
        title={modalTitle}
      >
        <ModalTransactionRanking
          params={ModalParams1}
          titleSetter={setModalTitle}
        />
      </ModalModule>
      <ModalModule
        isOpen={modalState2}
        closeModal={closeModal2}
        title={t('generic.spa.debitor_search')}
      >
        <ModalDebitorSearch setDebitor={setDebitor} />
      </ModalModule>
      <div className="spa-block-full" data-spa-type="transaction_ranking">
        <form className="">
          <div className="row mb-1" data-needs-role="sap_enter_customer_number">
            <div className="form-label-group col-md-6">
              <label htmlFor="customer_number">
                {t('generic.spa.customer_number')}
              </label>
              <input
                type="text"
                className="form-control"
                name="customer_number"
                required
                autoFocus
                value={InputData.customer_number}
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    customer_number: e.target.value,
                  })
                }
              />
              <div className="invalid-feedback">
                {t('generic.spa.customer_number_hint')}
              </div>
            </div>

            <div className="form-label-group col-md-6 position-relative">
              <small className="position-absolute" style={{ bottom: '0' }}>
                {t('generic.spa.customer_number_unknown') + ' '}
                <br />
                <a href="#" onClick={() => setModalState2(true)}>
                  {t('generic.spa.search_debitor')}
                </a>
              </small>
            </div>
          </div>

          <div className="row mb-1">
            <div className="form-label-group col-md-3">
              <label htmlFor="date_from">{t('generic.spa.from')}</label>
              <Datepicker
                selected={InputData.date_from}
                name="date_from"
                onChange={(date) =>
                  setInputData({
                    ...InputData,
                    date_from: date,
                  })
                }
              />
            </div>

            <div className="form-label-group col-md-3">
              <label htmlFor="date_to">{t('generic.spa.to')}</label>
              <Datepicker
                selected={InputData.date_to}
                name="date_to"
                onChange={(date) =>
                  setInputData({
                    ...InputData,
                    date_to: date,
                  })
                }
              />
            </div>

            <div className="form-label-group col-md-3">
              <label htmlFor="limit">{t('generic.spa.limit')}</label>
              <select
                id="limit"
                className="form-select"
                name="limit"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    limit: e.target.value,
                  })
                }
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
              </select>
            </div>

            <div
              className="form-label-group col-md-3"
              data-needs-role="sap_enter_customer_number"
            >
              <label htmlFor="internal">{t('generic.spa.show_names')}</label>
              <select
                id="internal"
                className="form-select"
                name="internal"
                onChange={(e) =>
                  setInputData({
                    ...InputData,
                    internal: e.target.value,
                  })
                }
              >
                <option value="false">{t('generic.spa.no')}</option>
                <option value="true">{t('generic.spa.yes')}</option>
              </select>
            </div>
          </div>

          <div className="row">
            <button
              className="btn btn-sm btn-primary col-md-3"
              type="submit"
              onClick={(e) => FormSubmit1(e)}
            >
              {t('generic.spa.transaction_ranking.show_ranking')}
            </button>

            <button
              className="btn btn-sm btn-link col-md-3"
              data-spa-behavior="transaction_debitor_ranking"
              data-needs-role="sap_enter_customer_number"
              style={{ color: '#343434' }}
              onClick={(e) => FormSubmit1(e, true)}
            >
              {t('generic.spa.transaction_ranking.show_revenue')}
            </button>
          </div>
        </form>
      </div>

      <div className="spa-block-full mt-2">
        <div data-spa-result-for="transaction_ranking">
          {loading && <LoadingSpinner />}
          {data?.response.ranking && data?.response.ranking.length > 0 && (
            <>
              <div className="spa-block-full mt-1 mb-2 text-center">
                <i className="fa fa-signal fa-3x"></i>
                <br />
                {t('generic.spa.results.transaction_ranking.place')}
                &nbsp;
                {data?.response.ranking[0].ranking}
              </div>
              <div className="spa-block-full mb-2">
                <h4 className="mb-1">{data?.response.ranking[0].name}</h4>
                <strong>
                  {t('generic.spa.results.transaction_ranking.revenue')}
                </strong>
                &nbsp;
                {div(data?.response.ranking[0].umsatz)}
                <br />
                <strong>
                  {t(
                    'generic.spa.results.transaction_ranking.work_order_items'
                  )}
                </strong>
                &nbsp;
                {data?.response.ranking[0].positionen}
                <br />
                <strong>
                  {t('generic.spa.results.transaction_ranking.ranking')}
                </strong>
                &nbsp;
                {data?.response.ranking[0].ranking}
                <br />
              </div>
            </>
          )}
          {data?.response.liste.length > 0 && (
            <table className="table table-condensed table-striped">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  {data?.params?.internal === 'true' && <th>Name</th>}
                  {data?.params?.furniture === 'true' &&
                    data?.params?.cumulative === 'true' && (
                      <th>
                        {t(
                          'generic.spa.results.transaction_ranking.material_number'
                        )}
                      </th>
                    )}
                  <th>
                    {t('generic.spa.results.transaction_ranking.revenue')}
                  </th>
                  <th>
                    {t(
                      'generic.spa.results.transaction_ranking.work_order_items'
                    )}
                  </th>
                  <th style={{ width: '40%' }}>
                    {t('generic.spa.results.transaction_ranking.comparison')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {data?.response.liste.map((liste, index) => (
                  <tr
                    key={index}
                    className={`${
                      parseInt(liste.kundennr) ===
                        parseInt(data?.params?.customer_number) &&
                      data?.params?.cumulative !== 'true'
                        ? 'font-weight-bold'
                        : ''
                    }`}
                  >
                    <td>{index + 1}</td>
                    {data?.params?.internal === 'true' && <td>{liste.name}</td>}
                    {data?.params?.furniture === 'true' &&
                      data?.params?.cumulative === 'true' && (
                        <td>
                          <>
                            {liste.matnr.length === 2 && (
                              <a
                                href="#"
                                onClick={() =>
                                  triggerModal1({
                                    customer_number: liste.kundennr,
                                    series_number: liste.matnr,
                                    cumulative: false,
                                    furniture: true,
                                    status: true,
                                  })
                                }
                              >
                                {liste.matnr}
                              </a>
                            )}
                            {liste.matnr.length !== 2 && liste.matnr}
                          </>
                        </td>
                      )}
                    <td data-sort-method="dotsep">{div(liste.umsatz)}</td>
                    <td>{liste.positionen}</td>
                    <td>
                      <div
                        className="revenue-graph"
                        style={{
                          width: graphPercent(
                            liste.umsatz,
                            data?.response.liste[0].umsatz
                          ),
                        }}
                      ></div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
      {/*
      <pre>{JSON.stringify(data, null, 2)}</pre>
      */}
    </>
  )
}

export default SapServiceTransactionRanking
